module.exports = __webpack_public_path__ + "static/media/by-bmo-logo.e3d00e9d.svg";